import { Helmet } from 'react-helmet-async';

const getCanonicalUrl = (canonical) => {
  if (canonical) return canonical;
  if (typeof window !== 'undefined') {
    return window.location.origin + window.location.pathname;
  }
  return 'https://mobiyo.app';
};

const SEO = ({ 
  title = 'mobiyo - Mobile App Review Management & AI Response Generation',
  description = 'mobiyo collects customer reviews for your mobile application, analyzes comments and generates responses with AI. Manage your app reviews efficiently with our AI-powered platform.',
  keywords = 'mobile app reviews, app review management, AI response generation, app store reviews, Google Play reviews, App Store reviews, review analytics',
  ogImage = '/og-image.png',
  ogUrl = 'https://mobiyo.app',
  ogType = 'website',
  twitterCard = 'summary_large_image',
  canonical
}) => {
  const canonicalUrl = getCanonicalUrl(canonical);
  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="robots" content="index, follow" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      
      {/* Open Graph Meta Tags */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:url" content={ogUrl} />
      <meta property="og:type" content={ogType} />
      
      {/* Twitter Card Meta Tags */}
      <meta name="twitter:card" content={twitterCard} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      
      {/* Favicon */}
      <link rel="icon" href="/favicon.ico" />
      <link rel="apple-touch-icon" href="/apple-touch-icon.png" />
      
      {/* Canonical URL */}
      <link rel="canonical" href={canonicalUrl} />
    </Helmet>
  );
};

export default SEO; 